<template>
  <el-popover ref="popover" placement="bottom-start" trigger="focus" :visible-arrow='false' v-model="visiable" @after-leave="afterLeave" @show="focus" @hide="blur" class="erop"
    popper-class="tips-con">
    <div class="mulity-menu-wrap" v-show="!isSearch" @click="handleVisible">
      <div class="menu-tab">
        <!-- <div class="hierarchy-name mb-10">一级</div> -->
        <el-scrollbar ref='clickselect' wrap-class="clickselect-scroll_wrap leftBox">
          <div class="menu-list">
            <div class="menu-item" :style="menuStyle" :class="{'opened': item.opened,'selected': item.selected, }" v-for="item in dataSource" :key="item.id" @mouseenter="handleShowTooltip($event)"
              @click="onSelect(item)">
              <el-tooltip class="item" effect="dark" :open-delay="500" :disabled='toolIsShow' :content="item.label" placement="top-start">
                <div class="menu-item-name textOverflow">
                  {{item.label}}
                </div>
              </el-tooltip>
              <span style="flex-shrink: 0;" v-show="getSecCount(item)">({{getSecCount(item)}})</span>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="menu-tab" :class="{'flex-box':type!=='area'}">
        <!-- <div class="hierarchy-name mb-10">二级</div> -->
        <el-scrollbar ref='clickselect' wrap-class="clickselect-scroll_wrap" class="second-menu">
          <div class="menu-list menu-flex-list">
            <div class="menu-select-all" :class="{'selected': currentSelect.selected}" @click="onSelectAll(currentSelect)">全部</div>
            <div class="second-menu-item">
              <div class="menu-item" :class="{'opened': item.opened,'selected': item.selected, 'leftBox area-menu-item':type==='area'}" v-for="(item) in currentSelect.childOption" :key="item.id"
                :style="menuStyle" @click="onSelectSecond(item)" @mouseenter="handleShowTooltip($event)">
                <el-tooltip class="item" effect="dark" :open-delay="500" :disabled='toolIsShow' :content="item.label" placement="top-start">
                  <div class="menu-item-name textOverflow">
                    {{item.label}}
                  </div>
                </el-tooltip>
                <i class="el-icon-check" v-if="item.selected" />
                <span v-if="type==='area' && getSecCount(item)">（{{getSecCount(item)}}）</span>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>

      <div class="menu-tab" v-if="type==='area'">
        <!-- <div class="hierarchy-name mb-10">三级</div> -->
        <el-scrollbar ref='clickselect' wrap-class="clickselect-scroll_wrap" class="second-menu">
          <div class="menu-list menu-flex-list">
            <div class="menu-select-all" :class="{'selected': threeLvselect.selected}" @click="onSelectAll(threeLvselect)">全部</div>
            <div class="second-menu-item">
              <div class="menu-item" :class="{'selected': item.selected}" v-for="(item) in threeLvselect.childOption" :key="item.label" @click="onSelectThird(item)"
                @mouseenter="handleShowTooltip($event)">
                <el-tooltip class="item" effect="dark" :open-delay="500" :disabled='toolIsShow' :content="item.label" placement="top-start">
                  <div class="menu-item-name textOverflow" :style="menuStyle">
                    <span style="width:150px" class="textOverflow">{{item.label}}</span><i class="el-icon-check" v-if="item.selected" />
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div class="mulity-menu-wrap mulity-menu-search" v-show="isSearch" @click="handleVisible">
      <div class="menu-tab flex-box">
        <el-scrollbar ref='clickselect' wrap-class="clickselect-scroll_wrap">
          <div class="suggestion-text">搜索结果：</div>
          <div class="menu-list">
            <div class="no-data" v-if="!searchResult.length">
              <span>未找到匹配的结果</span>
            </div>
            <template v-else>
              <div v-for="(item,i) in searchResult" :key="i" class="menu-item" :class="{'selected': item.data.selected}" @click="onSelectThird(item.data)">
                <div class="menu-item-name textOverflow" :class="['lv-'+item.lv]" :style="menuStyle">
                  {{item.data.label}}<i class="el-icon-check" v-if="item.data.selected" />
                </div>
              </div>
            </template>

          </div>
        </el-scrollbar>
      </div>
    </div>
    <div slot="reference">
      <tag-input v-model="value" ref="tagInput" class="tagInput" :class="{'error-border':error}" :allowEnter="false" :placeholder="placeholder0" @afterAdd='afterAdd' @getFocus="getFocus"
        @change="inputSearch" @deleteTag='handleVisible' />
    </div>
  </el-popover>
</template>

<script>
import Clickoutside from '@/utils/clickoutside'
import every from 'lodash/every'
import tagInput from './tagInput.vue'
import mixin from '../stopon.js'
import treeVue from '../tree.vue'
const deepClone = val => JSON.parse(JSON.stringify(val))

export default {
  name: "menuCommon",
  mixins: [mixin],
  components: {
    tagInput
  },
  props: ['defaultValue', 'options', 'error', 'type', 'pageType', 'placeholder'],
  directives: { Clickoutside },
  data() {
    // let cloneDataSource = JSON.parse(this.options) // 复制数据，保证数据隔离
    // let defaultSelect = cloneDataSource[0];
    const cloneDataSource = deepClone(this.options) // 复制数据
    const defaultSelect = cloneDataSource[0]
    this.$set(defaultSelect, 'opened', true)
    if (this.type === 'area') {
      var threeLvselect = cloneDataSource[0].childOption[0]
      this.$set(threeLvselect, 'opened', true)
    }
    return {
      isSearch: false,
      placeholder0: '请选择',
      value: [],
      menuStyle: { display: 'flex', 'justify-content': 'space-between', 'align-items': 'center' },

      searchVal: null, // 搜索关键字
      isSearch: false, // 是否搜索状态
      searchResult: [], // 搜索结果
      selectedNode: [], // 当前选中的集合
      visiable: false, // 弹窗是否显示
      dataSource: cloneDataSource, // 源数据
      currentSelect: defaultSelect, // 当前选中分类
      threeLvselect: threeLvselect,
      isEmpty: true,
      toolIsShow: false
    }
  },
  mounted() {
    this.initMenu()
    if (this.pageType == 'subscribe') {
      this.placeholder0 = this.placeholder
    }
  },
  methods: {
    getFocus() {
      if (!this.$refs.tagInput.word) {
        this.afterAdd()
      }
    },
    afterAdd() {
      this.isSearch = false
      this.refreshSelectBtn()
      this.updateValue()
      this.updateSelected()
      this.searchResult = []
    },
    inputSearch(val) {
      if (val) {
        this.isEmpty = false
        this.isSearch = true
        const searchList = []
        this.searchVal = val.trim()

        // 遍历查找搜索的值
        const fn = (source, lv) => {
          lv++
          source.forEach(item => {
            if (item.label.includes(val)) {
              searchList.push({ lv, data: item })
            }
            if (item.childOption && item.childOption.length) {
              fn(item.childOption, lv)
            }
          })
        }
        fn(this.dataSource, 0)

        // 对象数组去重
        let newsSearchList = []
        let obj = {};
        for (let i = 0; i < searchList.length; i++) {
          if (!obj[searchList[i].data.label]) {
            newsSearchList.push(searchList[i]);
            obj[searchList[i].data.label] = true;
          }
        }
        this.searchResult = newsSearchList
        // this.searchResult = searchList
      } else {
        this.isSearch = false
      }
    },
    handleShowTooltip(event) {
      const cell = event.target.querySelector('.el-tooltip')
      this.toolIsShow = cell.scrollWidth === cell.offsetWidth
      console.log('this.toolIsShow', this.toolIsShow)
    },
    /**
     * 根据数据初始化选择状态
     */
    initMenu() {
      if (this.defaultValue.length) {
        this.value = this.defaultValue
        this.handleVisible()
      }
    },

    /**
     * 弹层关闭动画结束之后回调
     * 清空输入内容，修改状态为正常，清空搜索列表
     */
    afterLeave() {
      // this.isSearch = false;
      // this.searchResult = [];
      // this.$emit('validateNode');
    },
    /**
     * 搜索
     */
    searchQueryString(e) {
      const event = window.event || e
      const val = event.target.value
      if (!val) {
        this.isSearch = false
        return
      }
      this.isEmpty = false
      this.isSearch = true
      const searchList = []
      this.searchVal = val.trim()
      this.dataSource.forEach(item => {
        let isPush = false
        if (item.value.indexOf(val) != -1) {
          isPush = true
          searchList.push({
            type: 'parent',
            data: item,
            keywordText: item.value.replace(val, val)
          })
        }
        // 二级行业
        item.sub.map((subItem, indexs) => {
          if (subItem.value.indexOf(val) != -1) {
            if (!isPush) {
              isPush = true
              searchList.push({
                type: 'parent',
                data: item,
                keywordText: item.value.replace(val, val)
              })
            }
            searchList.push({
              type: 'sub',
              data: subItem,
              parent: item,
              keywordText: subItem.value.replace(val, val)
            })
          }
        })
      })
      this.searchResult = searchList
    },

    /**
     * 获取分类选中数量
     */
    getSecCount(item) {
      if (!item.childOption) return false
      return item.childOption.filter(i => i.selected).length
    },
    /**
     * 切换已经分类
     */
    onSelect(item) {
      if (this.currentSelect.value === item.value && item.value) return
      this.currentSelect = item
      if (this.type === 'area') {
        this.threeLvselect = item.childOption[0]
        this.$set(this.threeLvselect, 'opened', true)
      }
      this.dataSource.forEach(e => {
        this.$set(e, 'opened', false)
      })
      this.$set(this.currentSelect, 'opened', true)
    },
    /**
     * 子节点全选事件 onSelectSecondAll
     */
    onSelectAll(item) {
      const flag = !item.selected
      const fn = (item) => {
        this.$set(item, 'selected', flag)
        item.childOption && item.childOption.forEach(e => { fn(e) })
      }
      fn(item)
      this.refreshSelectBtn()
      this.updateValue()
    },
    /**
     * 子节点选择事件
     */
    onSelectSecond(item) {
      if (this.type === 'area') {
        this.onSelectSecondArea(item)
      } else {
        const flag = !item.selected
        this.$set(item, 'selected', flag)
        if (this.type !== 'contactSiteSource') {
          this.refreshSelectBtn()
        }
        this.updateValue()
      }
    },
    onSelectSecondArea(item) {
      this.threeLvselect = item
      this.currentSelect.childOption.forEach(e => {
        this.$set(e, 'opened', false)
      })
      this.$set(this.threeLvselect, 'opened', true)
    },
    onSelectThird(item) {
      const flag = !item.selected
      this.$set(item, 'selected', flag)
      console.log("item, 'selected'", item)
      this.refreshSelectBtn()
      this.updateValue()
    },
    // 检测全选状态
    refreshSelectBtn() {
      this.threeLvselect && (this.threeLvselect.selected = this.isSeletedAll(this.threeLvselect))
      this.currentSelect && (this.currentSelect.selected = this.isSeletedAll(this.currentSelect))
    },

    /**
     * 判断当前分类是否全部选中
     */
    isSeletedAll(parent) {
      return every(parent.childOption, { selected: true })
    },
    /**
     * 更新当前选中项
     */
    updateValue() {
      const valueArr = []
      this.dataSource.forEach(item => {
        if (item.selected) {
          valueArr.push(item)
        } else {
          item.childOption && item.childOption.forEach(e => {
            if (e.selected) {
              valueArr.push(e)
            } else {
              e.childOption && e.childOption.forEach(child => {
                child.selected && valueArr.push(child)
              })
            }
          })
        }
      })
      this.value = valueArr
      this.$emit('change', valueArr)
    },
    // 回显 按 value 查找
    updateSelected() {
      const fn = (arr) => {
        arr.forEach(item => {
          item.selected = false
          if (this.type !== 'area') {
            if (this.value.findIndex(e => e.id === item.id) !== -1) {
              item.selected = true
              // item.childOption && item.childOption.forEach(e => { e.selected = true })
              item.childOption && item.childOption.forEach(e => {
                e.selected = true
                e.childOption && e.childOption.forEach(ee => {
                  ee.selected = true
                })
              })


            } else {
              item.childOption && fn(item.childOption)
            }
          } else {
            if (this.value.findIndex(e => e.value === item.value) !== -1) {
              item.selected = true
              // item.childOption && item.childOption.forEach(e => { e.selected = true })
              item.childOption && item.childOption.forEach(e => {
                e.selected = true
                e.childOption && e.childOption.forEach(ee => {
                  ee.selected = true
                })
              })


            } else {
              item.childOption && fn(item.childOption)
            }
          }

        })
      }
      fn(this.dataSource)
    },
    handleVisible() {
      this.updateSelected()
      this.updateValue()
    }
  }
}
</script>

<style lang='scss' scoped>
// %%
.tagInput {
  width: 300px;
}

.area-menu-item {
  display: flex;
}
.menu-tab {
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  box-sizing: border-box;
  width: 150px;
  .menu-select-all {
    height: 34px;
    line-height: 34px;
    cursor: pointer;
    &:hover {
      // background-color: #ebf0fe;
      color: #5088ff;
    }
    &.selected {
      color: #5088ff;
    }
    &.opened {
      color: #5088ff;
      // background-color: #ebf0fe;
    }
  }
  .menu-item {
    height: 30px;
    line-height: 30px;
    &:hover {
      // background-color: #ebf0fe;
      color: #5088ff;
    }
    &.selected {
      color: #5088ff;
    }
    &.opened {
      color: #5088ff;
      // background-color: #ebf0fe;
    }
    .menu-item-name {
      cursor: pointer;
      font-size: 14px;
      display: block !important;
      &.lv-2 {
        padding-left: 8px;
      }
      &.lv-3 {
        padding-left: 16px;
      }
    }
  }
  .hierarchy-name {
    color: #bfbfbf;
  }
  &:nth-of-type(2) {
    background: rgba(187, 190, 202, 0.1);
  }
  &:nth-last-of-type(1) {
    width: 172px;
    line-height: 22px;
  }
}

.second-menu {
  flex: 1;
}
</style>
<style lang="scss">
.erop {
  .el-popover {
    padding: 0;
  }
}
.tips-con {
  padding: 0;
}
.leftBox {
  // width: 150px;
  // padding-right: 10px;
  height: 100%;
}
.search-select-wrap {
  .tag-search {
    height: 100%;
    flex: 1;
    display: inline-block;
    width: 100%;
    border: none;
    font-size: 12px;
    font-weight: 400;
    color: #595959;
    line-height: 26px;
    height: 26px;
    outline: 0;
    padding: 0 8px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    &::placeholder {
      color: #bfbfbf;
    }
    &.focus {
      min-width: 100px;
    }
    .el-input__inner {
      border: none;
      height: 100%;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      line-height: 18px;
    }
  }
  .el-input__icon {
    line-height: 24px;
  }
}
.error-border {
  border-color: #f04134 !important;
  box-shadow: 0px 0px 4px 0px rgba(240, 65, 52, 0.4);
}
// 滚动区域大小
.mulity-menu-wrap {
  display: flex;
  // height: 380px;
  height: 204px;
  .clickselect-scroll_wrap {
    // height: 350px;
    // padding-bottom: 17px;
    // padding-right: 17px;
  }
}

.flex-box {
  width: 400px;
  .second-menu {
    .el-scrollbar__wrap {
      overflow-y: scroll;
      overflow-x: visible;
    }
  }
  .second-menu-item {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .menu-item-name {
      // width: 140px;
      width: 127px;
    }
  }
}
.menu-tab {
  .el-scrollbar {
    .el-scrollbar__wrap {
      overflow-y: scroll;
      overflow-x: visible;
    }
    height: 240px;
  }
}
</style>
